import { ref } from "vue";

export const now = ref(Date.now());
export const dateSub = (from, until) => {
  if (from < until) {
    const dt = until - from;
    if (0 < dt) {
      return new Date(dt);
    }
  }
};

setInterval(() => (now.value = Date.now()), 1000);
